import { Grid, FormControlLabel, Switch } from '@mui/material';
import { useState, useEffect, SetStateAction, Dispatch } from 'react';
import { IJob } from 'wisestep-api';
import { WsColors, WsTypography } from 'wisestep-base';

import JobsCard from '../jobCard';

interface JobsListingProps {
  onSelect: (job: IJob) => void;
  onDeSelect: (job: IJob) => void;
  jobs?: IJob[];
  selectedJob?: IJob[];
  setSelectedJobs: Dispatch<SetStateAction<IJob[]>>;
}

const JobsListing = ({
  onSelect,
  onDeSelect,
  setSelectedJobs,
  jobs = [],
  selectedJob = [],
}: JobsListingProps) => {
  const [allSelected, SetAllSelected] = useState(false);
  const [selectedJobIds, SetSelectedJobIds] = useState<string[]>([]);

  useEffect(() => {
    SetSelectedJobIds(selectedJob.map((job) => job?.id ?? ''));
  }, [selectedJob]);

  const onSelectAll = () => {
    SetAllSelected(!allSelected);
    if (!allSelected) {
      SetSelectedJobIds(jobs?.map((job) => job?.id ?? ''));
      setSelectedJobs(jobs);
    } else {
      SetSelectedJobIds([jobs[0]?.id ?? '']);
      setSelectedJobs([jobs[0]]);
    }
  };
  return (
    <>
      <Grid
        container
        width={'100%'}
        rowSpacing={1}
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1}
        sx={{
          backgroundColor: WsColors.White,
          borderBottom: `1px solid ${WsColors.BorderGrey}`,
        }}
        mt={1}
      >
        <Grid item>
          <WsTypography bold={true}>{` Similar Jobs (${jobs?.length ?? 0})`}</WsTypography>
        </Grid>
        <Grid item>
          <FormControlLabel
            sx={{
              padding: 0,
              margin: 0,
              fontWeight: 900,
              fontSize: '14px',
              '& .MuiFormControlLabel-label': {
                marginRight: 1,
              },
            }}
            control={
              <Switch
                disabled={false}
                size="medium"
                checked={allSelected}
                onChange={onSelectAll}
                sx={{
                  '& .MuiSwitch-track': {
                    backgroundColor: WsColors.GreyText,
                  },
                  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: WsColors.TheBlues500,
                  },
                }}
              />
            }
            label="Select all"
            labelPlacement="start"
          />
        </Grid>
      </Grid>
      <Grid
        container
        width={'100%'}
        rowSpacing={1}
        px={2}
        py={1}
        sx={{
          backgroundColor: WsColors.White,
          borderRadius: 2,
          border: `1px solid ${WsColors.BorderGrey}`,
        }}
        mt={1}
      >
        {jobs.map((job, index) => (
          <Grid item xs={12} key={index}>
            <JobsCard
              lastUpdated={job.createdOn?.toString() ?? ''}
              title={job.title ?? ''}
              jobCode={job.jobCode ?? ''}
              onSelect={() => {
                onSelect(job);
              }}
              onDeSelect={() => {
                SetAllSelected(false);
                onDeSelect(job);
              }}
              isSelected={selectedJobIds.includes(job?.id ?? '')}
              updatedText="Last updated:"
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
export default JobsListing;
